/**
 * Runtime theming: write brand CSS variables onto :root. Source can be a Setting
 * row (per-tenant brand) or a saved preference — no rebuild needed to rebrand.
 */
import { storageKey } from '@/lib/storageKey';

export function applyBrand(vars) {
  if (!vars) return;
  const root = document.documentElement;
  for (const [k, v] of Object.entries(vars)) {
    root.style.setProperty(k.startsWith('--') ? k : `--${k}`, v);
  }
}

const KEY = storageKey('brand');

export function saveBrand(vars) {
  try {
    localStorage.setItem(KEY, JSON.stringify(vars));
  } catch {}
  applyBrand(vars);
}

export function restoreBrand() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (v) applyBrand(v);
  } catch {}
}

/** Optionally pull the brand from the backend Setting model (key='brand'). */
export async function loadBrandFromApi(fetchApi) {
  try {
    const res = await fetchApi('crud', { model: 'Setting', action: 'list', where: { key: 'brand' } });
    const rows = Array.isArray(res) ? res : res && res.data;
    const row = rows && rows[0];
    if (row && row.value) saveBrand(JSON.parse(row.value));
  } catch {}
}
